<div class="tp-wrapper" [id]="item.id" [ngClass]="item.orientation">
  <div class="tp-box" [class.cursor-pointer]="allowFlipOnClick" [class.active]="flipped" [class.error]="errors" (click)="flipOnClick($event)" (mousedown)="onMouseDown($event)">
    <div class="tp-box__side tp-box__front d-flex"
      [class.video]="item.frontEmbedVideo || item.frontVideo"
      [dynamicWidthCoeff]="3"
      [cardBackground]="frontBackground"
      [class.default-background-color]="!item.frontBackgroundColor"
      [style.backdropFilter]="item.frontBackgroundBlur ? 'blur(' + item.frontBackgroundBlur + ')' : ''">
      @if (item.frontMediaBackground?.uploadingInProgress) {
        <mat-spinner class="image-loader" color="primary" [diameter]="20"></mat-spinner>
      }
      <lib-flipcard-side
        [side]="sides.FRONT"
        [item]="item"
        [slide]="slide"
        [canEdit]="canEdit"
        [isRtl]="isRtl"
        [isTranslation]="isTranslation"
        [ngClass]="'alignment-' + (item.frontAlignment || 'center')"
        (flip)="toggleFlip()"
        (edit)="edit.emit()"
        (remove)="remove.emit()"
        (changeOrientation)="changeOrientation.emit()"
        [textColor]="item.frontTextColor">
        <ng-content select="[drag-handle]" drag-handle></ng-content>
      </lib-flipcard-side>
    </div>
    <div class="tp-box__side tp-box__back d-flex"
      [class.video]="item.backEmbedVideo || item.backVideo"
      [dynamicWidthCoeff]="3"
      [cardBackground]="backBackground"
      [class.default-background-color]="!item.backBackgroundColor"
      [style.backdropFilter]="item.backBackgroundBlur ? 'blur(' + item.backBackgroundBlur + ')' : ''">
      @if (item.backMediaBackground?.uploadingInProgress) {
        <mat-spinner class="image-loader" color="primary" [diameter]="20"></mat-spinner>
      }
      <lib-flipcard-side
        [side]="sides.BACK"
        [item]="item"
        [slide]="slide"
        [canEdit]="canEdit"
        [isRtl]="isRtl"
        [isTranslation]="isTranslation"
        [ngClass]="'alignment-' + (item.backAlignment || 'center')"
        (flip)="toggleFlip()"
        (edit)="edit.emit()"
        (remove)="remove.emit()"
        (changeOrientation)="changeOrientation.emit()"
        [textColor]="item.backTextColor">
      </lib-flipcard-side>
    </div>
  </div>
</div>
